import { render, staticRenderFns } from "./AppointmentCompanion.vue?vue&type=template&id=87431294&scoped=true&"
import script from "./AppointmentCompanion.vue?vue&type=script&lang=js&"
export * from "./AppointmentCompanion.vue?vue&type=script&lang=js&"
import style0 from "./AppointmentCompanion.vue?vue&type=style&index=0&id=87431294&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87431294",
  null
  
)

export default component.exports